import "core-js/modules/es6.typed.uint8-array";
export default function parseToImageBitmap(arrayBuffer, options) {
  var blob = new Blob([new Uint8Array(arrayBuffer)]);
  var imagebitmapOptions = options && options.imagebitmap;
  return imagebitmapOptions ? createImageBitmap(blob) : createImageBitmap(blob, imagebitmapOptions);
}